import { Col, Descriptions, Row, Table, Typography } from 'antd';
import moment from 'moment';
import React, { useContext } from 'react';
import DescripcionPlan from '../../components/DescripcionPlan';
import EmpresaContext from '../../context/empresa-context';
import { formatCelular } from '../../utils';
import { formatoMonedaGenerico, redondear } from '../../utils/converters';
import { CalendarioPagos } from '../personal/Descripciones';

const { Title } = Typography;

const Asegurados = ({ asegurados, relacionesAsegurados }) => {
  if (!asegurados.list) {
    return null;
  }

  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'nombres',
      key: 'nombres',
      render: (text, row, index) => {
        if (index < asegurados.list.length) {
          return text;
        }
        return {
          children: row.footer ? <strong>{text}</strong> : text,
          props: {
            colSpan: 3
          }
        };
      }
    },
    {
      title: 'Cédula',
      dataIndex: 'cedula',
      key: 'cedula',
      render: (value, item, index) => {
        const obj = {
          props: {}
        };
        if (index === asegurados.list.length) {
          obj.props.colSpan = 0;
        }
        obj.children = value;
        return obj;
      }
    },
    {
      title: 'Relación de parentezco',
      dataIndex: 'tipo',
      key: 'tipo',
      render: (_, item, index) => {
        const obj = {
          props: {}
        };
        if (index === asegurados.list.length) {
          obj.props.colSpan = 0;
        }
        const relacion = relacionesAsegurados.find(
          (relacionItem) => relacionItem.value === item.tipo
        );
        if (!relacion) {
          obj.children = item.relacionOtro;
        } else {
          obj.children = relacion.label;
        }
        return obj;
      }
    }
  ];
  const listaRedondeada = asegurados.list.map((item) => ({
    ...item,
    monto: redondear(item.monto)
  }));
  const data = listaRedondeada.map((item, index) => ({
    ...item,
    key: `${index}`,
    monto: formatoMonedaGenerico(item.moneda, item.monto)
  }));

  return (
    <>
      {asegurados.list && (
        <>
          <Title level={5} style={{ textAlign: 'left', marginTop: 20 }}>
            Detalle de Asegurado/s para cobertura de Accidentes Personales
          </Title>
          <div>
            <Table
              fixed
              scroll={false}
              style={{ overflowX: 'auto' }}
              bordered
              dataSource={data}
              columns={columns}
              pagination={false}
            />
          </div>
        </>
      )}
    </>
  );
};

export const Vigencia = ({ vigenciaPago, tipo }) => {
  if (!vigenciaPago) {
    return null;
  }
  const columns = [
    {
      title: 'Vigencia',
      dataIndex: 'nombre',
      key: 'nombre',
      colSpan: 2,
      align: 'left',
      render: (text, row, index) => {
        if (index > 0) {
          return text;
        }
        return {
          children: text,
          props: {
            colSpan: 2
          }
        };
      }
    },
    {
      title: 'Valor',
      dataIndex: 'valor',
      key: 'valor',
      colSpan: 0,
      render: (value, row, index) => {
        const obj = {
          children: value,
          props: {}
        };
        if (index === 0) {
          obj.props.colSpan = 0;
        }
        return obj;
      }
    }
  ];

  const data = [
    {
      nombre:
        tipo === 'vehiculo'
          ? '* El inicio de la vigencia está sujeto al pago'
          : '* La vigencia será renovada por el mismo periodo recurrentemente, sujeto al pago',
      key: '0',
      valor: ''
    },
    {
      nombre: 'Desde',
      key: '1',
      valor: moment.isMoment(vigenciaPago.desde)
        ? vigenciaPago.desde.format('DD/MM/YYYY')
        : moment(vigenciaPago.desde).format('DD/MM/YYYY')
    },
    {
      nombre: 'Hasta',
      key: '2',
      valor: moment.isMoment(vigenciaPago.hasta)
        ? vigenciaPago.hasta.format('DD/MM/YYYY')
        : moment(vigenciaPago.hasta).format('DD/MM/YYYY')
    },
    {
      nombre: 'Días',
      key: '3',
      valor: vigenciaPago.cantidad_dias
    }
  ];

  return (
    <>
      <Descriptions
        title="Datos de Vigencia"
        style={{ textAlign: 'left', marginTop: 30 }}
      >
        <Descriptions.Item label="">
          <Table
            fixed
            scroll={false}
            style={{ width: '100%' }}
            bordered
            dataSource={data}
            columns={columns}
            pagination={false}
          />
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

const Beneficiarios = ({ beneficiarios, relaciones }) => {
  if (!beneficiarios.list) {
    return null;
  }

  if (beneficiarios.list && !beneficiarios.list[0].nombres) {
    return null;
  }
  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'nombres',
      key: 'nombres'
    },
    {
      title: 'Relación de parentezco',
      dataIndex: 'relacion',
      key: 'relacion',
      render: (_, item) => {
        // Si se le invoca desde el componente de Solicitud
        if (item.relacion === 'otro') {
          return item.relacionOtro;
        }
        return relaciones.find((relacion) => relacion.value === item.relacion)
          ? relaciones.find((relacion) => relacion.value === item.relacion)
              .label
          : item.relacion;
      }
    },
    {
      title: 'Porcentaje',
      dataIndex: 'beneficio',
      key: 'beneficio',
      align: 'right',
      render: (item) => `${item} %`
    }
  ];
  const data = beneficiarios.list.map((item, index) => ({
    ...item,
    key: `${index}`
  }));
  return (
    <>
      {beneficiarios.list && (
        <Descriptions
          title="Detalle de Beneficiario/s para cobertura de Accidentes Personales"
          style={{ textAlign: 'left', marginTop: 20 }}
        >
          <Descriptions.Item label="">
            <Table
              fixed
              scroll={false}
              style={{ width: '100%' }}
              bordered
              dataSource={data}
              columns={columns}
              pagination={false}
            />
          </Descriptions.Item>
        </Descriptions>
      )}
    </>
  );
};

const Contacto = ({ contacto, cuestionario, esJuridica }) => {
  const { tercero } = contacto;
  const { empresa } = useContext(EmpresaContext);
  const { empresaJuridica } = contacto;

  const getDescripcionesIngreso = (ingreso) => {
    switch (ingreso) {
      case '1':
        return '1.000.000 a 5.000.000';
      case '2':
        return '5.000.000 a 10.000.000';
      case '3':
        return '10.000.000 a 15.000.000';
      case '4':
        return 'Más de 15.000.000';
      default:
        return '-';
    }
  };

  return (
    <>
      {contacto && (
        <>
          {cuestionario && contacto.respuestas && (
            <>
              <br />
              <Descriptions
                title="Cuestionario"
                style={{ textAlign: 'left' }}
                column={{ md: 2, sm: 1, xs: 1 }}
                size="small"
              />

              {Object.keys(cuestionario).map((key) => (
                <Row
                  key={key}
                  justify="start"
                  style={{ marginBottom: 15, textAlign: 'left' }}
                >
                  <Col span={24} align="start">
                    <strong>{`${cuestionario[key]}`}</strong>
                  </Col>
                  <Col span={24} align="start">
                    {contacto.respuestas[key] === true && 'Si'}
                    {(contacto.respuestas[key] === false ||
                      contacto.respuestas[key] === '') &&
                      'No'}
                    {contacto.respuestas[key] !== true &&
                      contacto.respuestas[key] !== false &&
                      contacto.respuestas[key]}
                  </Col>
                </Row>
              ))}
            </>
          )}

          {esJuridica && (
            <Descriptions
              title="Datos de Asegurado"
              style={{ textAlign: 'left', marginTop: 20 }}
              column={{ md: 2, sm: 1, xs: 1 }}
              bordered
              size="small"
            >
              <Descriptions.Item label="Razón Social" span={2}>
                {empresaJuridica.razon}
              </Descriptions.Item>
              <Descriptions.Item label="CI / RUC">
                {empresaJuridica.ruc}
              </Descriptions.Item>
              <Descriptions.Item label="Dirección" span={2}>
                {empresaJuridica.domicilio}
              </Descriptions.Item>
              <Descriptions.Item label="Correo">
                {empresaJuridica.correo}
              </Descriptions.Item>
            </Descriptions>
          )}
          <Descriptions
            title={
              esJuridica
                ? 'Datos Personales del REPRESENTANTE LEGAL / FIRMANTE'
                : 'Datos de Asegurado'
            }
            style={{ textAlign: 'left', marginTop: 20 }}
            column={{ md: 2, sm: 1, xs: 1 }}
            bordered
            size="small"
          >
            <Descriptions.Item label="Nombre y Apellido" span={2}>
              {contacto.nombres}
            </Descriptions.Item>
            {(!esJuridica || (empresa.seprelad && esJuridica)) && (
              <Descriptions.Item label="RUC">{contacto.ruc}</Descriptions.Item>
            )}
            <Descriptions.Item label="Cédula">
              {contacto.cedula}
            </Descriptions.Item>
            <Descriptions.Item label="Celular">
              {`+595${contacto.celular}`}
            </Descriptions.Item>
            {(!esJuridica || (empresa.seprelad && esJuridica)) && (
              <>
                <Descriptions.Item label="Correo">
                  {contacto.correo}
                </Descriptions.Item>
                <Descriptions.Item label="Departamento">
                  {contacto.departamentoDescripcion}
                </Descriptions.Item>
                <Descriptions.Item label="Ciudad">
                  {contacto.distritoDescripcion}
                </Descriptions.Item>
                <Descriptions.Item label="Dirección" span={2}>
                  {contacto.domicilio}
                </Descriptions.Item>
                <Descriptions.Item label="Sexo">
                  {contacto.sexo}
                </Descriptions.Item>
                <Descriptions.Item label="Estado civil">
                  {contacto.estadoCivil}
                </Descriptions.Item>
                <Descriptions.Item label="Fecha nacimiento">
                  {contacto.fechaNacimiento &&
                    contacto.fechaNacimiento.format('DD/MM/YYYY')}
                </Descriptions.Item>
                <Descriptions.Item label="Nacionalidad">
                  {contacto.nacionalidad}
                </Descriptions.Item>
                <Descriptions.Item label="Lugar nacimiento">
                  {contacto.lugarNacimiento}
                </Descriptions.Item>
              </>
            )}
            {esJuridica && (
              <Descriptions.Item label="Cargo">
                {contacto.cargo}
              </Descriptions.Item>
            )}
          </Descriptions>

          <Descriptions
            title="Datos de Facturación"
            style={{ textAlign: 'left', marginTop: 20 }}
            column={{ md: 2, sm: 1, xs: 1 }}
            bordered
            size="small"
          >
            <Descriptions.Item label="Razón Social" span={2}>
              {tercero.nombres}
            </Descriptions.Item>
            <Descriptions.Item label="CI / RUC">
              {tercero.ruc}
            </Descriptions.Item>
            <Descriptions.Item label="Correo">
              {tercero.correo}
            </Descriptions.Item>
            <Descriptions.Item label="Departamento">
              {contacto.departamentoTerceroDescripcion}
            </Descriptions.Item>
            <Descriptions.Item label="Ciudad">
              {contacto.distritoTerceroDescripcion}
            </Descriptions.Item>
            <Descriptions.Item label="Dirección" span={2}>
              {tercero.domicilio}
            </Descriptions.Item>
            <Descriptions.Item label="Celular">
              {tercero.celular && `+595${tercero.celular}`}
            </Descriptions.Item>
            <Descriptions.Item label="Teléfono (Línea Baja)">
              {tercero.telefono}
            </Descriptions.Item>
          </Descriptions>
          {empresa.seprelad && (
            <>
              {!esJuridica && (
                <Descriptions
                  title="Datos Laborales"
                  style={{ textAlign: 'left', paddingTop: 40 }}
                  bordered
                  size="small"
                  column={{ md: 2, sm: 1, xs: 1 }}
                >
                  <Descriptions.Item label="RUC">
                    {contacto.ruc}
                  </Descriptions.Item>
                  <Descriptions.Item label="Rango de Ingresos Mensuales Personales (Gs.)">
                    {getDescripcionesIngreso(contacto.ingresos)}
                  </Descriptions.Item>
                  <Descriptions.Item label="¿Es Proveedor del Estado?">
                    {contacto.proveedorEstado ? 'Sí' : 'No'}
                  </Descriptions.Item>

                  <Descriptions.Item label="¿Es una Persona Expuesta Políticamente?">
                    {contacto.politicamenteExpuesto ? 'Sí' : 'No'}
                  </Descriptions.Item>
                  {contacto.politicamenteExpuesto && (
                    <>
                      <Descriptions.Item label="Cargo / Vínculo">
                        {contacto.vinculo}
                      </Descriptions.Item>
                      <Descriptions.Item label="Entidad">
                        {contacto.entidad}
                      </Descriptions.Item>
                      <Descriptions.Item label="Periodo">
                        {contacto.periodo[0]?.format('DD/MM/YYYY')} -{' '}
                        {contacto.periodo[1]?.format('DD/MM/YYYY')}
                      </Descriptions.Item>
                    </>
                  )}
                  <Descriptions.Item label="Tipo empleado">
                    {contacto.trabajo?.toUpperCase()}
                  </Descriptions.Item>
                  {contacto.institucion && (
                    <>
                      <Descriptions.Item label="Institución Pública">
                        {contacto.institucion || 'N/A'}
                      </Descriptions.Item>
                      <Descriptions.Item label="Cargo">
                        {contacto.cargo}
                      </Descriptions.Item>
                      <Descriptions.Item label="Año ingreso">
                        {contacto.anioIngreso}
                      </Descriptions.Item>
                    </>
                  )}
                  {(contacto.rucEmpleador || contacto.institucion) && (
                    <>
                      <Descriptions.Item label="RUC Empleador">
                        {contacto.rucEmpleador || 'A Confirmar'}
                      </Descriptions.Item>
                      <Descriptions.Item label="Empresa">
                        {contacto.empresaEmpleador}
                      </Descriptions.Item>
                      <Descriptions.Item label="Teléfono">
                        {contacto.telefonoEmpleador || 'A Confirmar'}
                      </Descriptions.Item>
                      <Descriptions.Item label="Celular">
                        {contacto.celularEmpleador
                          ? `+595${formatCelular(contacto.celularEmpleador)}`
                          : 'A Confirmar'}
                      </Descriptions.Item>
                      <Descriptions.Item label="Dirección">
                        {contacto.direccionEmpleador}
                      </Descriptions.Item>
                    </>
                  )}
                </Descriptions>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

const FormaPago = ({ contacto, aseguradora, listaMetodoPago, pagos }) => {
  return (
    <Descriptions
      title="Compañía y Forma de pago"
      style={{ textAlign: 'left', paddingTop: 40 }}
      bordered
      size="small"
      column={{ md: 2, sm: 1, xs: 1 }}
    >
      <Descriptions.Item label="Aseguradora">
        {aseguradora.descripcion ? aseguradora.descripcion : 'N/A'}
      </Descriptions.Item>
      <Descriptions.Item label="Medio de pago">
        {contacto.metodoPago
          ? listaMetodoPago.find((item) => item.id === contacto.metodoPago)
              .descripcion
          : ''}
      </Descriptions.Item>
      <Descriptions.Item label="Frecuencia de pago">
        {pagos?.frecuencia?.descripcion}
      </Descriptions.Item>
      <Descriptions.Item label="Cuotas" span={2}>
        {pagos?.cantidad_pagos}
      </Descriptions.Item>
    </Descriptions>
  );
};

const Inmueble = ({ contacto }) => {
  const { producto } = useContext(EmpresaContext);

  const columnsEstablecimiento = [
    {
      title: 'Tipo de Actividad',
      render: (_, record) => {
        if (record.label) {
          return `${record.label}`;
        }
        return '';
      }
    }
  ];

  const columnsRubro = [
    {
      title: 'Rubro',
      render: (_, record) => {
        if (record.label) {
          return `${record.label}`;
        }
        return '';
      }
    }
  ];

  return (
    <>
      {contacto && (
        <>
          <Descriptions
            title="Datos del Inmueble"
            style={{ textAlign: 'left' }}
            column={{ md: 2, sm: 1, xs: 1 }}
            bordered
            size="small"
          >
            <Descriptions.Item label="Departamento">
              {contacto.departamentoDescripcionInmueble}
            </Descriptions.Item>
            <Descriptions.Item label="Ciudad">
              {contacto.distritoDescripcionInmueble}
            </Descriptions.Item>
            <Descriptions.Item label="Dirección">
              {contacto.domicilioInmueble}
            </Descriptions.Item>
            <Descriptions.Item label="Cuenta Corriente Catastral Nro">
              {contacto.cuentaInmueble}
            </Descriptions.Item>
          </Descriptions>
          <br />

          {Number(producto) === 5 && (
            <>
              <Table
                fixed
                scroll={false}
                style={{ width: '100%' }}
                bordered
                dataSource={contacto.tipo_establecimiento}
                columns={columnsEstablecimiento}
                pagination={false}
                rowKey={(record) => record.id}
                size="small"
              />
              <br />
              <Table
                fixed
                scroll={false}
                style={{ width: '100%' }}
                bordered
                dataSource={contacto.rubro}
                columns={columnsRubro}
                pagination={false}
                rowKey={(record) => record.id}
                size="small"
              />
              <br />
            </>
          )}
        </>
      )}
    </>
  );
};

export const Construccion = ({ construccion }) => {
  const pisosDetalle = construccion.pisos
    .map((piso) => piso.descripcion)
    .join(', ');

  const paredesDetalles = construccion.paredes
    .map((pared) => pared.descripcion)
    .join(', ');

  const techosDetalle = construccion.techos
    .map((techo) => techo.descripcion)
    .join(', ');

  const cielorrasosDetalle = construccion.cielorrasos
    .map((cielorraso) => cielorraso.descripcion)
    .join(', ');

  const entrepisosDetalle = construccion.entrepisos
    .map((entrepiso) => entrepiso.descripcion)
    .join(', ');

  const cantidadNiveles =
    construccion.cantidadNiveles > 0
      ? construccion.cantidadNiveles
      : '+ Niveles';
  return (
    <>
      <Descriptions
        title="Características de Construcción"
        style={{ textAlign: 'left' }}
        column={{ md: 2, sm: 1, xs: 1 }}
        bordered
        size="small"
      >
        <Descriptions.Item label="Cielorraso">
          {cielorrasosDetalle}
        </Descriptions.Item>
        <Descriptions.Item label="Entrepiso">
          {entrepisosDetalle}
        </Descriptions.Item>
        <Descriptions.Item label="Pisos">{pisosDetalle}</Descriptions.Item>
        <Descriptions.Item label="Paredes">{paredesDetalles}</Descriptions.Item>
        <Descriptions.Item label="Techos">{techosDetalle}</Descriptions.Item>
        <Descriptions.Item label="Cantidad de niveles">
          {cantidadNiveles}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

const Descripciones = ({
  plan,
  listaMetodoPago,
  listaVigenciaPago,
  asegurados,
  relacionesAsegurados,
  beneficiarios,
  relaciones,
  contacto,
  cuestionario,
  aseguradora,
  listaModalidadPago,
  esJuridica,
  vigencia,
  pagos,
  calendarioList,
  construccion
}) => {
  return (
    <div style={{ maxWidth: '1000px', margin: 'auto' }}>
      <Inmueble {...{ contacto }} />
      {construccion && <Construccion {...{ construccion }} />}
      <Asegurados
        {...{
          asegurados,
          relacionesAsegurados,
          listaVigenciaPago,
          vigenciaPago: contacto.vigenciaPago
        }}
      />
      <Beneficiarios {...{ beneficiarios, relaciones }} />
      <DescripcionPlan {...{ plan }} />
      <Contacto {...{ contacto, listaMetodoPago, cuestionario, esJuridica }} />
      <Vigencia {...{ listaVigenciaPago, vigenciaPago: vigencia }} />

      <CalendarioPagos lista={calendarioList} moneda={plan[0].moneda} />
      <FormaPago
        {...{
          contacto,
          aseguradora,
          listaMetodoPago,
          listaModalidadPago,
          pagos
        }}
      />
    </div>
  );
};

export default Descripciones;
